export const restoreHiddenColumns = (columnsToDisplay: string[]) => {
  columnsToDisplay.splice(2, 0, 'bedrooms');
  columnsToDisplay.splice(2, 0, 'finishedSqFt');
  columnsToDisplay.splice(2, 0, 'lastSoldPrice');
  columnsToDisplay.splice(2, 0, 'distanceFromSource');
};
